"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = require("../../index");

var _style = require("./style");

var _spacers = require("../spacers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Button to hide/show widget
 * @param {function} toggleWidgetState
 */


var Launcher = function Launcher(_ref) {
  var toggleWidgetState = _ref.toggleWidgetState;

  var handleClick = function handleClick() {
    toggleWidgetState();
  };

  return /*#__PURE__*/_react["default"].createElement(_index.RoundedButton, {
    color: "#00B1DE",
    width: "16rem",
    borderRadius: "2.4rem",
    onClick: handleClick,
    alignItems: "center",
    padding: "0rem"
  }, /*#__PURE__*/_react["default"].createElement(_index.FlexRow, {
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_index.ChatBubble, {
    width: 25,
    height: 25,
    color: "#fff"
  }), /*#__PURE__*/_react["default"].createElement(_style.WebView, null, /*#__PURE__*/_react["default"].createElement(_index.FlexRow, {
    padding: "1.2rem 0"
  }, /*#__PURE__*/_react["default"].createElement(_spacers.VerticalSpacer, {
    width: "1.1rem"
  }), /*#__PURE__*/_react["default"].createElement(_index.Text, {
    size: "1.6rem",
    color: "#FFF"
  }, "Chat with us")))));
};

Launcher.propTypes = process.env.NODE_ENV !== "production" ? {
  toggleWidgetState: _propTypes["default"].func.isRequired
} : {};
var _default = Launcher;
exports["default"] = _default;
module.exports = exports["default"];